/* The separate subject pages were removed (founder, 13 Oct 2026): every subject link opens its
   catalog row, so the subject strip, the footer and the old short links all say one thing. */

/** Where a subject's link goes: its catalog row. */
export const subjectLink = (key: string) => `/classes?category=${key}`
